import { render, staticRenderFns } from "./my-comments.vue?vue&type=template&id=feb3449a&scoped=true&lang=html&"
import script from "./my-comments.vue?vue&type=script&lang=js&"
export * from "./my-comments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb3449a",
  null
  
)

export default component.exports